import { render, staticRenderFns } from "./BusinessPartner.vue?vue&type=template&id=0b790acf"
import script from "./BusinessPartner.vue?vue&type=script&lang=js"
export * from "./BusinessPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/srv/app/components/picture/Picture.vue').default,Markdown: require('/srv/app/components/markdown/Markdown.vue').default,ButtonLink: require('/srv/app/components/button/Link.vue').default})
